const modelInventoryFeatureLabel = 'Assessment';
const modelAssociationFeatureLabel = 'Sub-Process';
const modelRequestFeatureLabel = 'Product';
const useCaseFeatureLabel = 'Use Case';
const accessRequestFeatureLabel = 'Access Request';

export const LABEL_CONFIG_FCRA = {
  MENUS: {
    home: {
      label: 'Home',
      path: 'home',
    },
    inventory: {
      label: 'Inventory',
      path: 'inventory',
    },
    modelInventory: {
      label: 'Assessments',
      featureLabel: modelInventoryFeatureLabel, // If you are changing this change it in the template type as well
      path: 'assessments', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        createModel: {
          label: 'Add Assessment',
          path: 'assessments/add-assessment',
        },
        editModel: {
          label: 'Edit Assessment',
          path: 'assessments/:uniqueId',
        },
        archivedModelRequest: {
          label: 'Archived Assessments',
          path: 'assessments/archived',
        },
      },
    },
    modelRequest: {
      label: 'Products',
      featureLabel: modelRequestFeatureLabel, // If you are changing this change it in the template type as well
      path: 'products', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editModelRequest: {
          label: 'Edit Product',
          path: 'products/:uniqueId',
        },
        archivedModelRequest: {
          label: 'Archived Products',
          path: 'products/archived',
        },
      },
    },
    useCase: {
      label: 'Use Cases',
      featureLabel: useCaseFeatureLabel, // If you are changing this change it in the template type as well
      path: 'useCases', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editUseCase: {
          label: 'Edit Use Case',
          path: 'useCases/:uniqueId',
        },
        archivedUseCase: {
          label: 'Archived Use Cases',
          path: 'useCases/archived',
        },
      },
    },
    ModelAssociation: {
      label: 'Sub-Process',
      featureLabel: modelAssociationFeatureLabel, // If you are changing this change it in the template type as well
      path: 'sub-process', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        allArtifacts: {
          label: 'All Sub-Process',
          path: 'sub-process',
        },
        editModelAssociation: {
          label: 'Edit Sub-Process',
          path: 'sub-process/:uniqueId',
        },
        archivedArtifacts: {
          label: 'Archived Sub-Process',
          path: 'sub-process/archived',
        },
      },
    },
    DocumentInventory: {
      label: 'Documents',
      path: 'documents',
    },
    rules: {
      label: 'Rules',
      path: 'rules',
    },
    report: {
      label: 'Reports',
      path: 'reports',
    },
    bulkActions: {
      label: 'Bulk Upload',
      path: 'bulk-upload',
    },
    bulkDocumentUpload: {
      label: 'Bulk Document Upload',
      path: 'bulk-document',
    },
    Configuration: {
      label: 'Configuration',
      path: 'configuration',
    },
    globalAttributes: {
      label: 'Global Attributes',
      featureLabel: 'Global Attributes',
      path: 'global-attributes',
    },
    Attributes: {
      label: 'Attributes',
      featureLabel: 'Attributes',
      path: 'attributes',
    },
    constantAttributes: {
      label: 'Constant Attributes',
      featureLabel: 'Constant Attributes',
      path: 'constant-attributes',
    },
    teamRoles: {
      label: 'Team Roles',
      featureLabel: 'Team Roles',
      path: 'team-roles',
    },
    workflow: {
      label: 'Workflows',
      featureLabel: 'Workflow',
      path: 'workflows', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editWorkflow: {
          label: 'Edit Workflow',
          path: 'workflows/edit-workflow/:workflowType/:workflowId',
        },
        generateWorkflow: {
          label: 'Generate Workflow',
          path: 'workflows/generate-workflow',
        },
      },
    },
    templateList: {
      label: 'Templates',
      path: 'templates', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        createTemplate: {
          label: 'Create Template',
          path: 'templates/create-template',
        },
        editTemplate: {
          label: 'Edit Template',
          path: 'templates/edit-template/:tId/:vId',
        },
      },
    },
    documentTemplate: {
      label: 'Document Template',
      path: 'document-template',
    },
    dynamicChart: {
      label: 'Dynamic Chart',
      path: 'dynamic-chart',
    },
    dynamicToolbar: {
      label: 'Dynamic Toolbar',
      featureLabel: 'Dynamic Toolbar',
      path: 'dynamic-toolbar',
      subPaths: {
        createDynamicToolbar: {
          label: 'Create Dynamic Toolbar',
          path: 'dynamic-toolbar/new',
        },
        editDynamicToolbar: {
          label: 'Edit Dynamic Toolbar',
          path: 'dynamic-toolbar/:uniqueId',
        },
      },
    },
    automation: {
      label: 'Automation',
      path: 'automation', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        createAutomation: {
          label: 'Create Automation',
          path: 'automation/create-automation',
        },
        updateAutomation: {
          label: 'Update Automation',
          path: 'automation/update-automation/:id',
        },
        automationLineage: {
          label: 'Automation Lineage',
          path: 'automation/lineage/:id',
        },
      },
    },
    themeAndAppearance: {
      label: 'Theme and Appearance',
      path: 'theme-and-appearance',
    },
    emailTemplate: {
      label: 'Email Template',
      path: 'email-template',
    },
    helpAndSupport: {
      label: 'Help and Support',
      path: 'help',
    },
    administrativeOptions: {
      label: 'Administrative Options',
      path: 'administrative-options',
    },
    userManagement: {
      label: 'User Management',
      path: 'user-management',
    },
    accessRequest: {
      label: 'Access Request',
      featureLabel: accessRequestFeatureLabel, // If you are changing this change it in the template type as well
      path: 'accessRequest', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editAccessRequest: {
          label: 'Edit Access Request',
          path: 'accessRequest/:uniqueId',
        },
      },
    },
    homepageSetup: {
      label: 'Homepage Setup',
      path: 'homepage-setup',
    },
    logs: {
      label: 'Logs',
      path: 'logs',
      subPaths: {
        configurationLogs: {
          label: 'System Logs',
          path: 'logs/system-logs',
        },
        inventoryLogs: {
          label: 'Inventory Logs',
          path: 'logs/inventory-logs',
        },
      },
    },
  },
  LABELS: {
    modelInventory: {
      otherDetails: {
        label: 'Evaluation Overview',
      },
      modelLifecycleEventDropdown: {
        label: 'Assessment Type',
      },
      table: {
        column: {
          ModelHealth: {
            label: 'Risk Profile',
          },
        },
      },
    },
    modelAssociation: {
      otherDetails: {
        label: 'Questionnaire',
      },
      artifactLifecycleEventDropdown: {
        label: 'Assessment Type',
      },
      table: {
        column: {
          ArtifactHealth: {
            label: 'Risk Profile',
          },
        },
      },
    },
    useCase: {
      usecaseLifecycleEventDropdown: {
        label: 'Assessment Type',
      },
    },
    modelRequest: {
      modelRequestLifecycleEventDropdown: {
        label: 'Assessment Type',
      },
    },
    userManagement: {
      groups: {
        label: 'Groups',
        uppercaseLabel: 'GROUPS',
      },
      group: {
        label: 'Group',
        uppercaseLabel: 'GROUP',
      },
      table: {
        column: {
          role: {
            label: 'ROLE',
          },
        },
      },
    },
  },
  // If you are changing this part, then make sure you are changing the paths and menus labels to these.
  TEMPLATE_TYPES: {
    ModelInventory: {
      label: 'Assessment',
      featureLabel: modelInventoryFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    ModelAssociation: {
      label: 'Sub-Process',
      featureLabel: modelAssociationFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    ModelRequest: {
      label: 'Product',
      featureLabel: modelRequestFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    AccessRequest: {
      label: 'Access Request',
      featureLabel: accessRequestFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    UseCase: {
      label: 'Use Case',
      featureLabel: useCaseFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
  },
};
